<template>
  <div class="blogMainArticle">
    <div class="blogMainArticle__inner">
      <div class="blogMainArticle__item">
        <blog-large-tile :item="items[0]" horizontal :lazy="lazy" />
      </div>
    </div>
    <div class="blogMainArticle__mobile" v-if="showAll">
      <v-button
        :to="localePath({ name: 'blog' })"
        small-height
        text="Wszystkie wpisy"
        theme="purple"
      />
    </div>
  </div>
</template>

<script>
import BlogLargeTile from './BlogLargeTile.vue';
import BlogBigTile from '~/components/Blog/BlogBigTile';
import BlogTile from '~/components/Blog/BlogTile';
import BorderLink from '~/components/BorderLink';
import VButton from '~/components/VButton';

export default {
  name: 'BlogMainArticle',
  components: {
    BlogBigTile,
    BlogLargeTile,
    BlogTile,
    BorderLink,
    VButton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'Artykuły i porady',
    },
    showAll: {
      type: Boolean,
      default: false,
    },
    lazy: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.blogMainArticle {
  margin-bottom: 4.8rem;
  &__headerLink {
    @include rwd('tablet') {
      display: none;
    }
  }

  &__inner {
    display: flex;
    flex-wrap: wrap;
    margin: 0;
  }

  &__col {
    flex-direction: column;
    display: flex;
    flex: 0 0 50%;
    max-width: 50%;
    padding: 0 20px;

    @include rwd('large-tablet') {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  &__item {
    height: 100%;

    @include rwd('large-tablet') {
      margin-bottom: 4rem;
    }
  }

  &__smallItem {
    margin-bottom: 4rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__mobile {
    display: none;
    justify-content: center;
    margin-top: 3rem;

    @include rwd('tablet') {
      display: flex;
    }
  }
}
</style>
